export const getEvseSafePvScheduleLocalStorageKey = (evseDeviceId: string): string => {
  return `evse-${evseDeviceId}-immediate-calendar`
}

export const getEvseEfficientPvScheduleLocalStorageKey = (evseDeviceId: string): string => {
  return `evse-${evseDeviceId}-delayed-calendar`
}
